import { STATUS } from '@/lib/constants/cspm'

const CLOUD_SECURITY = {
  DASHBOARD: {
    TITLE: 'Panel de Seguridad en la Nube',
    PROVIDER: 'Proveedor',
    ACCOUNT: 'Cuenta',
    STATUS_TITLE: 'Distribución por Estado',
    ALL_ACCOUNTS: 'Todas las cuentas',
    SEVERITY_TITLE: 'Distribución por Severidad',
    SECURITY_POSTURE_TRENDS_TITLE: 'Tendencia de Postura de Seguridad',
    LAST_SCAN: 'Último escaneo',
    TOP_AFFECTED_REGIONS_TITLE: 'Regiones Afectadas',
    TOP_AFFECTED_SERVICES_TITLE: 'Servicios Afectados',
    TOP_AFFECTED_NO_DATA: 'No se encontraron problemas',
    SYSTEM_HEALTH: 'Salud del Sistema',
    FAILED_OUT_OF: 'fallidos de',
    TOTAL_ISSUES: 'Problemas',
    PASSED_CHECKS: 'Checks Aprobados',
    FAILED_CHECKS: 'Checks Fallidos',
    CRITICAL_ISSUES: 'Problemas Críticos',
    TOP_REGION: 'Región Principal',
    TOP_SERVICE: 'Servicio Principal',
    ISSUES_LABEL: 'problemas',
    PASSED_LABEL: 'Aprobados',
    FAILED_LABEL: 'Fallidos',
    STATUS: {
      [STATUS.PASSED]: 'Aprobado',
      [STATUS.FAILED]: 'Rechazado',
    },
  },
  MISCONFIGURATIONS: {
    TITLE: 'Configuraciones Inseguras',
    DETAIL_ERROR: 'No se han podido cargar los detalles de este finding. Inténtalo de nuevo.',
    FILTER_BY_ACCOUNT_PROVIDER: 'Filtrar por Cuenta y Proveedor',
    PROVIDER: 'Proveedor',
    ACCOUNT: 'Cuenta',
    NO_FINDINGS_FOUND: 'No se encontraron configuraciones inseguras',
    SEARCH_PLACEHOLDER: 'Buscar configuraciones inseguras...',
    SUMMARY: 'Resumen',
    STATUS: {
      OPEN: 'Fallido',
      CLOSED: 'Pasado',
      MUTED: 'Silenciado',
    },
    FILTERS: {
      PROVIDERS: 'Proveedores',
      ACCOUNTS: 'Cuentas',
      SERVICES: 'Servicios',
      REGIONS: 'Regiones',
    },
    ATTRIBUTES: {
      ACCOUNT: 'Cuenta',
      CLI_COMMAND: 'Comando CLI',
      DATE_DETECTED: 'Fecha de Detección',
      DESCRIPTION: 'Descripción',
      FINDING_NAME: 'Finding',
      LAST_DETECTED: 'Última Detección',
      LAST_UPDATED: 'Fecha de Actualización',
      OCCURRENCES: 'Ocurrencias',
      PROVIDER: 'Proveedor',
      RECOMMENDATION_URLS: 'URLs de Recomendación',
      REGION: 'Región',
      REMEDIATION: 'Remediación',
      RESOURCE_ID: 'ID del Recurso',
      RESOURCE_NAME: 'Nombre del Recurso',
      RISK: 'Riesgo',
      SERVICE: 'Servicio',
      SEVERITY: 'Severidad',
      STATUS: 'Estado',
      TIMELINE: 'Línea de Tiempo',
    },
    MONITORING: {
      LABEL: 'Monitoreo',
    },
    MUTE: {
      MUTE_BUTTON: 'Silenciar finding',
      UNMUTE_BUTTON: 'Reactivar finding',
      DIALOG_TITLE: 'Motivo del silenciado',
      SELECTION_SUMMARY: (selected: number, total: number) =>
        `${selected} de ${total} instancias afectadas seleccionadas`,
      JUSTIFICATION_LABEL: 'Justificación',
      JUSTIFICATION_PLACEHOLDER:
        '¿Por qué se silencia este finding? p. ej. control compensatorio implantado, riesgo aceptado hasta la migración del Q4',
      CANCEL: 'Cancelar',
      BANNER_TITLE: (muted: number, total: number) => `Silenciado · ${muted} de ${total} instancias afectadas`,
      MUTED_BADGE: 'Silenciado',
      MUTED_BY: (name: string) => `Silenciado por ${name}`,
      BY_SCANNER: 'Silenciado por el escáner de cloud',
      NOTHING_SELECTED_TOOLTIP: 'Selecciona al menos una instancia afectada',
      DORMANT_NOTE: 'Este silenciado se volverá a aplicar si el finding falla en un futuro escaneo',
      MUTE_SUCCESS: 'Finding silenciado',
      UNMUTE_SUCCESS: 'Finding reactivado',
      MUTE_PARTIAL: (muted: number, requested: number) =>
        `Silenciadas ${muted} de ${requested} instancias — el resto ya no están abiertas`,
      UNMUTE_PARTIAL: (unmuted: number, requested: number) =>
        `Reactivadas ${unmuted} de ${requested} instancias — el resto ya no estaban silenciadas`,
      MUTE_ERROR: 'No se pudo silenciar el finding',
      UNMUTE_ERROR: 'No se pudo reactivar el finding',
    },
  },
}
export default CLOUD_SECURITY
